import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import FileUpload from '@/components/FileUpload/index.vue';
import { updateAdmin, defaultAdminData, getAdminById } from '@/api/admins';
import { getAgentById } from '@/api/agents';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.avatar = [];
    this.formData = Object.assign({}, defaultAdminData);
    this.data = {};
    this.isAgent = false;
    this.agentData = {};
    this.adminData = {};
  }
  activated() {
    if (AdminModule.userType === 'Agent') {
      this.isAgent = true;
      this.fetchData(AdminModule.agentId, AdminModule.userType);
    } else {
      this.fetchData(AdminModule.id, AdminModule.userType);
    }
  }
  async fetchData(id, type) {
    try {
      if (type === 'Agent') {
        const data = await getAgentById(id);
        this.formData = data;
        this.agentData = data;
      } else {
        const data = await getAdminById(id);
        this.formData = data;
        this.adminData = data;
      }
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async submit() {
    try {
      await updateAdmin(this.formData.id, this.formData);
      this.$message({
        message: 'User information has been updated successfully',
        type: 'success',
        duration: 5 * 1000
      });
    } catch (err) {} // eslint-disable-line  no-empty
  }
  fileUploaded(file) {
    this.formData.avatar = file.response;
  }
};
__decorate([Prop({
  required: true
})], default_1.prototype, "user", void 0);
default_1 = __decorate([Component({
  name: 'Account',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;